<div class="row mt-3 mb-3">
  <div class="col-12">
    <button (click)="inserir()" #btnAdicionar class="btn btn-sm btn-outline-primary">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar aditamento
    </button>
  </div>
</div>
<table class="table table-eddy">
  <thead>
    <tr>
      <th scope="col" style="min-width: 110px">Data</th>
      <th scope="col" style="min-width: 110px">Data Início</th>
      <th scope="col" style="min-width: 110px">Data Término</th>
      <th scope="col" style="min-width: 130px">Data Contabilização</th>
      <th scope="col" style="width: 30%">Finalidade</th>
      <th scope="col" style="width: 40%">Descrição</th>
      <th scope="col" style="min-width: 120px">Valor Transferido</th>
      <th scope="col" style="min-width: 120px">Valor Contra Part.</th>
      <th scope="col" style="min-width: 120px">Valor Total</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of listaAditamentos; let idx = index">
      <td *ngIf="!item.editavel">{{item.data_aditamento | date: 'dd/MM/yyyy':'GMT'}}</td>
      <td *ngIf="!item.editavel">{{item.data_inicio | date: 'dd/MM/yyyy':'GMT'}}</td>
      <td *ngIf="!item.editavel">{{item.data_termino | date: 'dd/MM/yyyy':'GMT'}}</td>
      <td *ngIf="!item.editavel">{{item.data_contabilizacao | date: 'dd/MM/yyyy':'GMT'}}</td>
      <td *ngIf="!item.editavel">{{obterFinalidade(item.finalidade)}}</td>
      <td *ngIf="!item.editavel">{{item.descricao}}</td>
      <td *ngIf="!item.editavel">{{item.valor_transferencia | number: '1.2-2'}}</td>
      <td *ngIf="!item.editavel">{{item.valor_contrapartida | number: '1.2-2'}}</td>
      <td *ngIf="!item.editavel">{{item.valor_total | number: '1.2-2'}}</td>

      <td *ngIf="item.editavel && entity">
        <p-calendar id="data_aditamento" [(ngModel)]="entity.data_aditamento" inputStyleClass="form-control"
          dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" class="ui-calendar-small"
          [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </td>
      <td *ngIf="item.editavel && entity">
        <p-calendar id="data_inicio" [(ngModel)]="entity.data_inicio" inputStyleClass="form-control" dataType="date"
          dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" class="ui-calendar-small" [showOnFocus]="false"
          [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </td>
      <td *ngIf="item.editavel && entity">
        <p-calendar id="data_termino" [(ngModel)]="entity.data_termino" inputStyleClass="form-control" dataType="date"
          dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" class="ui-calendar-small" [showOnFocus]="false"
          [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </td>
      <td *ngIf="item.editavel && entity">
        <p-calendar id="data_contabilizacao" [(ngModel)]="entity.data_contabilizacao" inputStyleClass="form-control"
          dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" class="ui-calendar-small"
          [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </td>
      <td *ngIf="item.editavel && entity">
        <select [compareWith]="compareFn" id="finalidade" [(ngModel)]="entity.finalidade" class="custom-select">
          <option [ngValue]="item.id" *ngFor="let item of listaFinalidade">
            {{item.nome}}
          </option>
        </select>
      </td>
      <td *ngIf="item.editavel && entity">
        <input [(ngModel)]="entity.descricao" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="descricao">
      </td>
      <td *ngIf="item.editavel && entity">
        <input [(ngModel)]="entity.valor_transferencia" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" unmask="true" [imask]="imaskConfig" id="valor_transferencia"
          placeholder="0,00">
      </td>
      <td *ngIf="item.editavel && entity">
        <input [(ngModel)]="entity.valor_contrapartida" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" unmask="true" [imask]="imaskConfig" id="valor_contrapartida"
          placeholder="0,00">
      </td>
      <td *ngIf="item.editavel && entity">
        <input [(ngModel)]="entity.valor_total" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" unmask="true" [imask]="imaskConfig" id="valor_total" placeholder="0,00">
      </td>
      <td class="text-right" style="min-width: 110px;">
        <button *ngIf="!item.editavel" (click)="editar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="confirmarRemocao(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>

<app-convenio-aditamento-dlg [(lista)]="listaAditamentos" [(entidade)]="entity" [login]="login">
</app-convenio-aditamento-dlg>